/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { withRouter } from 'react-router';
import { configure } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import AppLoader from '../../stores/appLoader';
import Busy from '../busy';
import MaskedApp from '../maskedApp';
import DownloadError from '../error/downloadError';
import AppsSkeleton from '../appsSkeleton';
import Config from '../../stores/config';
import DialogManager from '../../stores/dialogManager';
import TranslationUtil from '../../utils/translation';
import './index.scss';
import '../../styles/global.scss';
import { downloadErrorAnalytics } from '../../analytics/commonAnalytics';

configure({ enforceActions: 'observed' });

class Apps extends React.Component {
    componentWillMount() {
        const { intl } = this.props;
        TranslationUtil.setIntl(intl);
    }

    componentDidMount() {
        const { intl } = this.props;
        TranslationUtil.setIntl(intl);
        DialogManager.init(Config.dialogManager);
    }

    render() {
        const { props } = this;
        const { loading } = AppLoader;
        const { showDownloadError, isMasked } = Config;
        if (isMasked) {
            return <MaskedApp />;
        }
        if (loading) {
            return <Busy />;
        }
        if (showDownloadError) {
            downloadErrorAnalytics();
            return <DownloadError />;
        }

        return (
            props.match ? (
                <div key={0} className="cc-apps-container">
                    <AppsSkeleton
                        {...props}
                    />
                </div>
            ) : <div key={1} />
        );
    }
}

Apps.propTypes = {
    intl: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default withRouter(observer(Apps));
